<template>
  <div class="update-message" v-loading="loading">
    <div class="top">
      <Myavatar
        width="64px"
        height="64px"
        fontSize="18px"
        :imgUrl="dataset.updated_user ? dataset.updated_user.user_avatar : ''"
        :userName="dataset.updated_user ? dataset.updated_user.realname : ''"
      >
      </Myavatar>
      <span class="name">{{dataset.updated_user ? dataset.updated_user.realname : ''}}</span>
    </div>
    <div class="cell">
      <div class="title">
        <span>更新原因</span>
        <span>更新时间: {{dataset.create_time ? dataset.create_time.replace(/-/g, '/') : ''}}</span>
      </div>
      <div class="content">{{ dataset.updated_reason }}</div>
    </div>
    <div class="cell-2" v-if="dataset.updated_content">
      <div class="title">
        <span>更新内容</span>
      </div>
      <div class="cell--item">
        <div class="cell-l"  v-for="(item, key) in dataset.updated_content" v-html="message(key, item )"></div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api/product/product'
export default {
  props: ['id'],
  data() {
    return {
      dataset: {},
      loading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      let result = await api.productUpdateHistoriesRed({id: this.id})
      this.dataset = result
      this.loading = false
    },
    message(key, item) {
      // console.log('----------asd-', key, item)
      let str = ''
      switch (key) {
        case 'images':
          str = this.getStr('图片', item, 2)
          break
        case 'product_name':
          str = this.getStr('项目名称', item, 1)
          break
        case 'development_status':
          str = this.getStr('研制状态', item, 1)
          break
        case 'product_series_id':
          str = this.getStr('所属系列', item, 1)
          break
        case 'highlights':
          str = this.getStr('产品亮点', item, 1)
          break
        case 'create_project_attachments':
          str = this.getStr('产品立项文件', item, 2)
          break
        case 'information_attachments':
          str = this.getStr('产品资料文件', item, 2)
          break
        case 'description':
          str = this.getStr('产品概述', item, 1)
          break
        case 'status_description':
          str = this.getStr('产品状态', item, 1)
          break
        case 'remark':
          str = this.getStr('备注', item, 1)
          break
      }
      return str
    },
    getStr(name, val, type) {
      let str = ''
      switch (type) {
        case 1:
          if (!val.old_data || val.old_data === '') {
            str =  `<div class="message-box">
              <div class="message-cell">
                <span class="title">新增了 ${name}: </span>
                <span class="message-content">${val.new_data}</span>
              </div>
            </div>`
          } else {
            str =  `<div class="message-box">
              <div class="message-cell">
                <span class="title">原 ${name}: </span>
                <span class="message-content">${val.old_data}</span>
              </div>
              <div class="message-cell">
                <span class="title">修改为: </span>
                <span class="message-content">${val.new_data}</span>
              </div>
            </div>`
          }
          break
        case 2:
          let add_data = this.fileNameHandle(val.add_data)
          let delete_data = this.fileNameHandle(val.delete_data)
          console.log(add_data, delete_data)
          if (add_data && add_data.length > 0) {
            str =  `<div class="message-box">
              <div class="message-cell">
                <span class="title">新增了 ${name}: </span>
                <span class="message-content">${add_data.map(res => res.attachment_name).join('、')}</span>
              </div>
            </div>`
          }
          if (delete_data && delete_data.length > 0) {
            str +=  `<div class="message-box">
              <div class="message-cell">
                <span class="title">删除了 ${name}: </span>
                <span class="message-content">${delete_data.map(res => res.attachment_name).join('、')}</span>
              </div>
            </div>`
          }
          break
      }
      return str
    },
    fileNameHandle(val) {
      if(!val) return []
      return Object.entries(val).map(([key, value]) => value)
    }
  },
}
</script>
<style lang="scss">
.update-message {
  padding-top: 14px;
  padding-bottom: 16px;
  .top {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 32px;
    .name {
      margin-top: 16px;
      font-size: 18px;
      font-weight: 500;
    }
  }
  .cell {
    .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      span:first-child {
        font-size: 16px;
        font-weight: 500;
      }
      span:last-child {
        font-size: 14px;
        color: rgba(32, 32, 32, 0.60);
      }
    }
    .content {
      background-color: rgba(32, 32, 32, 0.04);
      padding: 16px;
      line-height: 20px;
      font-size: 14px;
      color: rgba(32, 32, 32, 0.80);
    }
  }
  .cell-2 {
    margin-top: 15px;
    &>.title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      span {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .cell--item {
      display: flex;
      flex-direction: column;
    }
    .message-box {
      font-size: 14px;
      line-height: 20px;
      padding: 16px 0;
      border-bottom: 1px solid rgba(32, 32, 32, 0.07);
      .title {
        font-weight: bold;
        margin-right: 8px;
      }
      .message-cell + .message-cell {
        margin-top: 16px;
      }
    }
  }
}
</style>
